module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


// WEBPACK FOOTER //
// webpack:///node_modules/babel-runtime/core-js/is-iterable.js